import { MessageUI } from "./types";
import { formatMessageTime } from "@/utils/formatMessageTime";

export function ChatMessageOut({ message }: { message: MessageUI }) {
  return (
    <>
      <div className="flex items-start space-x-2 md:space-x-3">
        <div className="w-8 h-8 md:w-10 md:h-10 bg-[#6B8E5A] rounded-xl flex items-center justify-center flex-shrink-0 mt-1">
          <img
            src="/assets/images/logo.png"
            alt="麻薏 Mayi AI Logo"
            className="w-10 h-10 mx-auto bg-warm-beige rounded-xl warm-shadow"
          />
        </div>
        <div className="message-bubble bg-white border border-gray-200 rounded-2xl rounded-tl-md px-4 py-3 shadow-sm">
          <p className="text-lg md:text-base text-[#A0956B] leading-relaxed">
            {message.content}
          </p>
          <div className="text-xs text-[#A0956B]/70 mt-1">
            {formatMessageTime(message.timestamp)}
          </div>
        </div>
      </div>
    </>
  );
}
